<template>
  <div class="files-page">
    <div class="container">
      <!-- 页面头部 - 用户信息 -->
      <el-row type="flex" justify="start" align="middle" class="page-header" style="z-index: 2;">
        <el-col :span="11">
          <el-row type="flex" justify="start" align="middle">
            <el-col>
              <h2 class="page-title">用户信息</h2>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="13" style="text-align: right">
          <el-button 
            type="danger" 
            icon="el-icon-switch-button"
            size="medium" 
            @click="handleLogout">
            退出登录
          </el-button>
        </el-col>
      </el-row>

      <!-- 用户信息卡片 -->
      <el-card class="user-info-card" body-style="padding:10px;" v-loading="userLoading" style="z-index: 1;">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-descriptions title="" :column="1" border size="medium">
              <el-descriptions-item label="姓名">
                <el-tag size="medium">{{userInfo.username}}</el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="部门">
                <el-tag type="success" size="medium">{{userInfo.department}}</el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="手机号">
                <el-tag type="info" size="medium">{{userInfo.phone}}</el-tag>
              </el-descriptions-item>
            </el-descriptions>
          </el-col>
        </el-row>
      </el-card>

      <!-- 文件列表头部 -->
      <el-row type="flex" justify="start" align="middle" class="page-header" style="z-index: 2;">
        <el-col :span="11">
          <el-row type="flex" justify="start" align="middle">
            <el-col>
              <h2 class="page-title">项目日志</h2>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="13" style="text-align: right">
          <el-button 
            type="primary" 
            icon="el-icon-plus"
            size="medium" 
            @click="showCreateDialog">
            新建日志
          </el-button>
        </el-col>
      </el-row>

      <!-- 文件列表表格 -->
      <el-table :data="filteredTableData" style="width: 100%; margin-top: 0px; z-index: 1;" v-loading="loading">
        <el-table-column label="日期" prop="date" sortable></el-table-column>
        <el-table-column label="类型" prop="type"></el-table-column>
        <el-table-column label="操作" align="right">
          <template slot="header">
            <el-input
              v-model="search"
              size="small"
              placeholder="关键字搜索"
              style="width: 100%;"/>
          </template>
          <template slot-scope="scope">
            <div class="action-column">
              <el-button
                size="mini"
                type="primary"
                @click="handleDownload(scope.$index, scope.row)">下载</el-button>
              <el-button
                size="mini"
                type="primary"
                @click="handleEdit(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 新建日志对话框 -->
      <el-dialog
        title="新建日志"
        width="90%"
        top="2vh"
        :visible.sync="createDialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <div class="create-dialog-content">
          <!-- 日期选择器 -->
          <div class="date-picker-container">
            <h3 style="margin-top: 0px;">选择日期</h3>
            <el-date-picker
              v-model="selectedCreateDate"
              type="date"
              placeholder="选择日期"
              :picker-options="datePickerOptions"
              format="yyyy-MM-dd"
              value-format="yyyyMMdd"
              style="width: 100%;"
              @change="handleDateChange"
            ></el-date-picker>
          </div>
          
          <!-- 日志类型列表 -->
          <div v-if="selectedCreateDate" class="log-types-container">
            <h3>选择日志类型</h3>
            <div v-loading="logTypesLoading">
              <!-- 可用的日志类型 -->
              <div v-if="availableLogTypes.length > 0">
                <div 
                  v-for="type in availableLogTypes" 
                  :key="type"
                  class="log-type-item"
                >
                  <span class="log-type-name">{{ type }}</span>
                  <el-button 
                    type="primary" 
                    size="small"
                    @click="createLog(type)"
                  >
                    新建
                  </el-button>
                </div>
              </div>
              
              <!-- 没有可用的日志类型 -->
              <div v-else-if="!logTypesLoading" class="no-log-types">
                <el-alert
                  title="当前日期已创建了所有类型的日志"
                  type="info"
                  :closable="false"
                  show-icon
                ></el-alert>
              </div>
            </div>
          </div>
        </div>
        
        <span slot="footer" class="dialog-footer">
          <el-button @click="createDialogVisible = false">取消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilesPage',
  data() {
    return {
      tableData: [],
      search: '',
      loading: true,
      currentDate: new Date(),
      selectedDate: new Date().getFullYear().toString() + (new Date().getMonth() + 1).toString().padStart(2, '0'),
      userLoading: true,
      userInfo: {
        username: '',
        department: '',
        phone: ''
      },
      // 新增数据
      createDialogVisible: false,
      selectedCreateDate: null,
      datePickerOptions: {
        disabledDate(time) {
          // 禁用今天之后的日期
          return time.getTime() > Date.now();
        }
      },
      availableLogTypes: [],
      logTypesLoading: false
    }
  },
  
  // 添加路由守卫，防止从编辑页面返回
  beforeRouteEnter(to, from, next) {
    // 如果是从编辑页面返回，则重定向到文件列表页面
    if (from.path === '/editor') {
      // 这里直接调用next()，因为我们已经在文件列表页面了
      next();
      // 修改浏览器历史记录，移除编辑页面的记录
      window.history.replaceState(null, '', '/files');
    } 
    // 如果是从登录页面返回，也阻止返回
    else if (from.path === '/login') {
      next();
      // 修改浏览器历史记录，移除登录页面的记录
      window.history.replaceState(null, '', '/files');
    }
    else {
      next();
    }
  },
  
  computed: {
    filteredTableData() {
      return this.tableData.filter(data => {
        const searchStr = this.search.toLowerCase();
        return !this.search || 
               data.type.toLowerCase().includes(searchStr) ||
               data.date.includes(searchStr);
      });
    }
  },
  methods: {
    // 显示创建日志对话框
    showCreateDialog() {
      this.createDialogVisible = true;
      this.selectedCreateDate = new Date().toISOString().slice(0, 10).replace(/-/g, '');
      this.handleDateChange(this.selectedCreateDate);
    },
    
    // 处理日期变更
    async handleDateChange(date) {
      if (!date) {
        this.availableLogTypes = [];
        return;
      }
      
      try {
        this.logTypesLoading = true;
        
        // 构造日期参数
        const selectedDate = date;
        
        // 获取可用的日志类型
        const response = await fetch(`/api/log_templates?date=${selectedDate}`);
        if (!response.ok) {
          throw new Error('获取日志类型失败');
        }
        
        const data = await response.json();
        if (data.status === 'success') {
          this.availableLogTypes = data.log_types || [];
        } else {
          throw new Error(data.error || '获取日志类型失败');
        }
      } catch (error) {
        this.$message.error(error.message);
        this.availableLogTypes = [];
      } finally {
        this.logTypesLoading = false;
      }
    },
    
    // 创建日志
    createLog(logType) {
      this.createDialogVisible = false;
      
      // 构造查询参数
      const query = { 
        from: '/files',
        date: this.selectedCreateDate,
        type: logType,
        phone: this.userInfo.phone,
        username: this.userInfo.username
      };
      
      // 跳转到编辑页面
      this.$parent.setTransition('slide-left');
      this.$router.push({
        path: '/editor',
        query: query
      });
    },
    
    // 原有的创建方法改为直接调用showCreateDialog
    handleCreate() {
      this.showCreateDialog();
    },
    
    handleEdit(row) {
      this.$parent.setTransition('slide-left')
      this.$router.push({
        path: `/editor`,
        query: { 
          filename: row.filename,
          from: '/files'
        }
      })
    },
    async handleDelete(index, row) {
      try {
        await this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        const response = await fetch(`/api/delete_file?filename=${row.filename}`);
        if (response.ok) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.loadFiles();
        } else {
          throw new Error('删除失败');
        }
      } catch (err) {
        if (err !== 'cancel') {
          this.$message({
            type: 'error',
            message: '删除失败'
          });
        }
      }
    },
    async handleDownload(index, row) {
      try {
        const response = await fetch('/api/get_download_token', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            filename: row.filename
          })
        });
        
        if (!response.ok) {
          throw new Error('获取下载token失败');
        }
        
        const data = await response.json();
        window.location.href = `/api/download?filename=${row.filename}&token=${data.token}`;
      } catch (err) {
        this.$message({
          type: 'error',
          message: '下载失败'
        });
      }
    },
    async loadFiles() {
      try {
        this.loading = true;
        const now = Date.now();
        const cache = this.$root.$data.globalCache;
        
        if (cache.files && 
            (now - cache.lastCacheTime) < 300000) {
          this.tableData = cache.files;
          this.loading = false;
          return;
        }

        const year = this.selectedDate.substring(0, 4);
        const month = this.selectedDate.substring(4);
        const response = await fetch(`/api/filter_files?year=${year}&month=${month}`);
        if (!response.ok) {
          throw new Error('加载文件列表失败');
        }
        const data = await response.json();
        this.tableData = data.files.map(file => ({
          ...file,
          date: file.date
        }));
        
        // 更新缓存
        cache.files = this.tableData;
        cache.lastCacheTime = now;
      } catch (err) {
        this.$message({
          type: 'error',
          message: '加载文件列表失败'
        });
      } finally {
        this.loading = false;
      }
    },
    async loadUserInfo() {
      try {
        this.userLoading = true;
        const cache = this.$root.$data.globalCache;
        
        if (cache.userInfo) {
          this.userInfo = cache.userInfo;
          this.userLoading = false;
          return;
        }

        const userResponse = await fetch('/api/manage_users');
        if (!userResponse.ok) {
          throw new Error('获取用户信息失败');
        }
        const userData = await userResponse.json();
        console.log('userData', userData);
        console.log('userData.users', userData.users);
        console.log('userData.status', userData.status);
        // 处理用户数据
        if (userData.status === 'success' && userData.users && userData.users.length > 0) {
          this.userInfo = {
            username: userData.users[0].username,
            department: userData.users[0].department,
            phone: userData.users[0].phone
          };
          console.log('this.userInfo', this.userInfo);
        } else {
          console.error('加载用户列表失败:', userData.message)
        }
        
        // 更新缓存
        cache.userInfo = this.userInfo;
      } catch (err) {
        this.$message({
          type: 'error',
          message: '获取用户信息失败'
        });
      } finally {
        this.userLoading = false;
      }
    },
    async handleLogout() {
      try {
        const response = await fetch('/api/logout');
        const data = await response.json();
        if (data.success) {
          this.clearCache();
          this.$router.push('/login');
        } else {
          throw new Error('退出失败');
        }
      } catch (err) {
        this.$message({
          type: 'error',
          message: '退出失败'
        });
      }
    },
    async checkAuth() {
      try {
        const response = await fetch('/api/check_auth');
        if (!response.ok) {
          throw new Error('认证检查失败');
        }
        const data = await response.json();
        if (!data.authenticated) {
          this.$message({
            type: 'warning',
            message: '请先登录'
          });
          this.$router.push('/login');
          return false;
        }
        return true;
      } catch (err) {
        this.$message({
          type: 'error',
          message: '认证检查失败'
        });
        this.$router.push('/login');
        return false;
      }
    },
    async initializeData() {
      const isAuthenticated = await this.checkAuth();
      if (isAuthenticated) {
        await Promise.all([
          this.loadFiles(),
          this.loadUserInfo()
        ]);
      }
    },
    clearCache() {
      const cache = this.$root.$data.globalCache;
      cache.files = null;
      cache.userInfo = null;
      cache.lastCacheTime = 0;
    }
  },
  created() {
    if (!this.$root.$data.globalCache) {
      this.$root.$data.globalCache = {
        files: null,
        userInfo: null,
        lastCacheTime: 0
      }
    }
    this.initializeData();
  }
}
</script>

<style scoped>
.files-page {
  min-height: 100vh;
  background-color: #f5f7fa;
}

.container {
  max-width: 1200px;
  min-width: 300px;
  margin: 0 auto;
  padding: 20px;
}

.page-header {
  margin-bottom: 0px;
  background: white;
  padding: 15px 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
}

.page-title {
  font-size: 20px;
  color: #303133;
  margin: 0;
  font-weight: 500;
}

.user-info-card {
  margin-bottom: 10px;
}

.user-info-card .el-descriptions {
  margin-bottom: 0;
}

.user-info-card .el-tag {
  margin: 0;
}

.action-column {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.el-button+.el-button {
    margin-left: 0px;
}

/* 对话框样式 */
::v-deep .el-dialog__body {
  padding: 0px 40px !important;
}

/* 新增样式 */
.create-dialog-content {
  padding: 10px 0;
}

.date-picker-container,
.log-types-container {
  margin-bottom: 0px;
}

.date-picker-container h3,
.log-types-container h3 {
  font-size: 16px;
  margin-bottom: 10px;
  color: #303133;
  /* font-weight: 500; */
  min-height: 30px;
}

.log-type-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 10px;
}

.log-type-name {
  font-size: 14px;
  color: #606266;
}

.no-log-types {
  margin-top: 20px;
}

@media screen and (max-width: 768px) {
  .container {
    padding: 10px;
  }
  
  .page-header {
    padding: 10px 15px;
  }
  
  .el-descriptions-item {
    margin-bottom: 10px;
  }
}

@media screen and (max-width: 480px) {
  .action-column {
    flex-direction: column;
    gap: 5px;
  }
  
  .el-button--mini {
    width: 100%;
  }
}
</style>
